import dynamic from "next/dynamic";

export const DynamicFooter001 = dynamic(() => import("./Footer001"), {
  suspense: true,
});
